import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-empty-state',
  templateUrl: './empty-state.component.html',
  styleUrls: ['./empty-state.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmptyStateComponent {
  @Input() icon = 'layers-outline';
  @Input() title = '';
  @Input() message = '';
  @Input() actionLabel = '';
  @Input() actionIcon = 'add-outline';
  @Input() showAction = false;
  @Output() action = new EventEmitter<void>();
}
